import { createContext, useCallback, useContext, useLayoutEffect, useMemo, useState } from "react";

/** Public site tema tercihi; admin rotalarından bağımsız (bkz. AdminSection). */
export const STORAGE_KEY = "dekosta-public-theme";

const ThemeCtx = createContext(null);

function readStoredTheme() {
  if (typeof window === "undefined") return "light";
  try {
    const v = window.localStorage.getItem(STORAGE_KEY);
    return v === "dark" ? "dark" : "light";
  } catch {
    return "light";
  }
}

function applyDomTheme(theme) {
  const root = document.documentElement;
  root.setAttribute("data-theme", theme);
  root.classList.toggle("dark", theme === "dark");
}

/** Sadece public Layout (anasayfa, teklif vb.) ile sınırlı — admin etkilenmez. */
export function PublicThemeProvider({ children }) {
  const [theme, setTheme] = useState(readStoredTheme);

  useLayoutEffect(() => {
    applyDomTheme(theme);
    try {
      window.localStorage.setItem(STORAGE_KEY, theme);
    } catch {
      /* ignore */
    }
  }, [theme]);

  const toggleTheme = useCallback(() => {
    setTheme((t) => (t === "dark" ? "light" : "dark"));
  }, []);

  const value = useMemo(
    () => ({
      theme,
      setTheme,
      toggleTheme,
      resolvedIsDark: theme === "dark",
    }),
    [theme, toggleTheme],
  );

  return <ThemeCtx.Provider value={value}>{children}</ThemeCtx.Provider>;
}

export function usePublicTheme() {
  const ctx = useContext(ThemeCtx);
  if (!ctx) {
    throw new Error("usePublicTheme yalnızca PublicThemeProvider içinde kullanılmalıdır");
  }
  return ctx;
}

/** Projede daha kısa isim olarak */
export function useTheme() {
  return usePublicTheme();
}
